import { render } from "./EditorTypeComponent.vue?vue&type=template&id=17055817&scoped=true"
import script from "./EditorTypeComponent.vue?vue&type=script&lang=js"
export * from "./EditorTypeComponent.vue?vue&type=script&lang=js"

import "./EditorTypeComponent.vue?vue&type=style&index=0&id=17055817&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17055817"]])

export default __exports__